import { EmptyResult } from '@package/services/src/Result'
import getCreditCardType from '@package/utils/src/creditCard/getCreditCardType'
import { CheckoutPaymentFormData } from '../types'
import { CardPaymentService } from './services'
import { CheckoutWithCreditCardRequest } from './types'

export default class CardPaymentInteractor {
  public constructor(
    private cardPaymentService: CardPaymentService
  ) { }

  private mapDataForCreditCardMethod(
    data: CheckoutPaymentFormData
  ): CheckoutWithCreditCardRequest {
    return {
      creditCardNumber: data.creditCardNumber.replace(/\s/g, ''),
      expirationDate: `${data.expirationMonth}/${new Date()
        .getFullYear()
        .toString()
        .slice(0, 2)}${data.expirationYear}`,
      cardType: getCreditCardType(data.creditCardNumber.replace(/\s/g, '')),
      cid: data.cid,
    }
  }

  public async checkout(
    request: CheckoutPaymentFormData
  ): Promise<EmptyResult> {
    const creditCardData = this.mapDataForCreditCardMethod(request)

    return this.cardPaymentService.checkout(creditCardData)
  }
}
